import { setUserId, track } from './track'

export type HiveCallsPromoPlacement = 'dialog' | 'sheet' | 'sidebar'
export type HiveCallsStore = 'google_play' | 'app_store'

export const analytics = {
  identify: (userId: string | null) => setUserId(userId),
  clearIdentity: () => setUserId(null),
  logoutFromCompleteSignUp: () => track('logout_from_complete_sign_up'),
  signInFromMissionOnBoarding: (projectId: string) => track('conversion_event_signup_2', {
    mission_id: projectId,
  }),

  missionOpened: (projectId: string, projectType: string) =>
    track('mission_opened', { project_id: projectId, project_type: projectType }),
  missionState: (projectId: string, enrollmentStatus: string) =>
    track('mission_state', { project_id: projectId, enrollment_status: enrollmentStatus }),
  missionTaskSubmitted: (projectId: string, taskId: string, taskIndex: number) =>
    track('mission_task_submitted', {
      project_id: projectId,
      task_id: taskId,
      task_index: taskIndex > -1 ? taskIndex + 1 : taskIndex
    }),
  missionAllTasksDone: (projectId: string) => track('mission_all_tasks_done', { project_id: projectId }),
  missionCompleted: (projectId: string, projectType: string) =>
    track('mission_completed', { project_id: projectId, project_type: projectType }),
  missionExpired: (projectId: string, projectType: string) =>
    track('mission_expired', { project_id: projectId, project_type: projectType }),

  micCheckPassed: (projectId: string) => track('mic_check_passed', { project_id: projectId }),
  micCheckDismissed: (projectId: string, issue: string | null) =>
    track('mic_check_dismissed', { project_id: projectId, issue }),
  micCheckFailed: (projectId: string, issue: string | null) =>
    track('mic_check_failed', { project_id: projectId, issue }),
  recordingQualityBlocked: (projectId: string, issue: string) =>
    track('recording_quality_blocked', { project_id: projectId, issue }),
  recordingQualityWarned: (projectId: string, issue: string) =>
    track('recording_quality_warned', { project_id: projectId, issue }),

  languageScreeningSubmitted: (projectId: string, language: string) =>
    track('language_screening_submitted', { project_id: projectId, language }),

  assessmentPhase: ({ projectId, phase }: { projectId?: string; phase: string }) =>
    track('assessment_phase', { project_id: projectId, phase }),
  assessmentCompleted: ({ projectId, level }: { projectId?: string; level: string }) =>
    track('assessment_completed', { project_id: projectId, level }),

  missionOnboardingStepCTA: (projectId: string, step: string) =>
    track('mission_onboarding:step_cta', { project_id: projectId, step }),
  missionOnboardingFullCapacity: (projectId: string) =>
    track('mission_onboarding:full_capacity', { project_id: projectId }),
  missionOnboardingLanguageMismatch: (projectId: string) =>
    track('mission_onboarding:language_mismatch', { project_id: projectId }),

  hiveCallsPromoShown: (placement: Exclude<HiveCallsPromoPlacement, 'sidebar'>) =>
    track('hive_calls_promo:shown', { placement }),
  hiveCallsPromoStoreClick: (placement: HiveCallsPromoPlacement, store: HiveCallsStore) =>
    track('hive_calls_promo:store_click', { placement, store }),
  hiveCallsPromoDismissed: (placement: Exclude<HiveCallsPromoPlacement, 'sidebar'>) =>
    track('hive_calls_promo:dismissed', { placement }),

  audioTaskPlayerToggle: (
    projectId: string,
    taskId: string,
    action: 'play' | 'pause',
    attemptIndex: number
  ) =>
    track('audio_task_player_toggle', {
      project_id: projectId,
      task_id: taskId,
      action,
      attempt_index: attemptIndex
    }),
  audioTaskTextEdited: (projectId: string, taskId: string, length: number) =>
    track('audio_task_text_edited', { project_id: projectId, task_id: taskId, length }),

  profileUpdated: () => track('profile_updated')
}
